import { OnBoardingContainer } from '../../../OnBoardingContainer';
import { OnBoardingWrapper } from '../../../OnBoardingWrapper';
import { OnboardingContinueButton } from '../../agent/components/OnboardingContinueButton';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { Question } from 'pages/RequestQuote/components';
import { AnswersContainer } from 'pages/Workshop/Transactions/TransactionCreate/components/PreForm/AnswersContainer';
import { ButtonsContainer } from 'pages/Workshop/Transactions/TransactionCreate/components/PreForm/ButtonsContainer';
import { useDispatch, useSelector } from 'react-redux';
import { onBoardingSignUpEffect } from 'store/effects/onBoarding';
import { PENDING } from 'settings/constants/apiState';
import { getOnBoardingData } from 'pages/OnBoarding/selectors';
import { getUserDataSelector } from 'store/selectors/user';
import { getCategories } from 'api/admin';
import { Spinner } from 'components';
import { Plus, Minus } from 'components/Icons';
import { Select } from 'antd';
import { showErrorMessage } from 'helpers';

type Props = {
  onNext: () => {};
  stageIndex?: number;
  Controls: React.ElementType;
};

export const CategoryForm: React.FC<Props> = ({ onNext, stageIndex, Controls }) => {
  const dispatch = useDispatch();
  const { onBoarding } = useSelector(getOnBoardingData);
  const user = useSelector(getUserDataSelector);
  const [allCategories, setAllCategories] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [isOne, setIsOne] = useState<boolean>(true);

  const isPending = onBoarding.state === PENDING;

  useEffect(() => {
    if (!allCategories.length) fetchAllCategories();
  }, []);

  useEffect(() => {
    if (user?.ThirdParty?.Partner?.PartnerCategories?.length) {
      if (user.ThirdParty.Partner.PartnerCategories.length > 1) setIsOne(false);
      setSelectedCategories([...user.ThirdParty.Partner.PartnerCategories]);
    }
  }, [user]);

  const fetchAllCategories = async () => {
    setIsLoading(true);
    try {
      const response = await getCategories({ active: true });
      if (response.status === 200) {
        setAllCategories(response?.data?.result?.length ? [...response.data.result] : []);
      }
    } catch (e) {
      setAllCategories([]);
    }
    setIsLoading(false);
  };

  const onSubmit = () => {
    dispatch(
      onBoardingSignUpEffect(
        {
          PartnerCategories: selectedCategories.map((cat) => cat.Id),
          stageIndex,
        },
        { isCommonInfo: true },
        (err) => {
          if (!err) {
            onNext();
          }
        },
      ),
    );
  };

  const handleDropdownChange = (value: any, index: number) => {
    const numVal = Number(value);
    const exits = selectedCategories.find((cat) => cat && cat.Id === numVal);
    if (exits) {
      showErrorMessage('Category already selected');
      return;
    }
    const category = allCategories.find((cat) => cat.Id === numVal);
    if (category) {
      setSelectedCategories((prev) => {
        const newCategories = [...prev];
        newCategories[index] = category;
        return newCategories;
      });
    }
  };

  if (loading) return <Spinner />;

  return (
    <OnBoardingWrapper isPending={isPending} className={styles.wrapper}>
      <Controls onNext={onSubmit} variant="lightFull" className={styles.controls} />
      <OnBoardingContainer className={styles.obContainer}>
        <Question className={styles.partnerTitle}>
          <span>
            Your profile will be published in the following category. Do you want to be included in
            any others?
          </span>
        </Question>
        <AnswersContainer className={styles.answersContainer}>
          <div className={styles.categoryForm}>
            {selectedCategories.map((category, index) => {
              if (isOne && index === 0)
                return (
                  <div className={styles.category}>
                    <img src={category.Icon} alt={category.Title} className={styles.icon} />
                    {category.Title}
                  </div>
                );
              return (
                <div className={styles.categoryInputContainer}>
                  <div className={styles.categoryDD}>
                    {category ? (
                      <img src={category.Icon} alt={category.Title} className={styles.icon} />
                    ) : (
                      <div className={styles.icon}></div>
                    )}
                    <Select
                      className={styles.dropdown}
                      bordered={false}
                      onChange={(value) => handleDropdownChange(value, index)}
                      placeholder="Select Category"
                      value={category ? category.Id.toString() : undefined}
                      options={
                        allCategories.length
                          ? allCategories.map((cat) => ({
                              value: cat.Id.toString(),
                              label: cat.Title,
                            }))
                          : []
                      }
                    />
                  </div>
                  <Minus
                    className={styles.minus}
                    onClick={() => {
                      setSelectedCategories((prev) => prev.filter((_, i) => i !== index));
                    }}
                    color="#fff"
                  />
                </div>
              );
            })}
            <div
              className={styles.add}
              onClick={() => {
                setSelectedCategories((prev) => [...prev, undefined]);
              }}
            >
              <Plus className={styles.plus} color={'#515151'} />
              {'Add Another'}
            </div>
          </div>
        </AnswersContainer>
        <ButtonsContainer buttonsContainerClassName={styles.buttonsContainer}>
          <OnboardingContinueButton
            htmlType="submit"
            testid="next"
            isPending={isPending}
            disabled={!selectedCategories.length}
            onClick={onSubmit}
            className={styles.submit}
          />
        </ButtonsContainer>
      </OnBoardingContainer>
    </OnBoardingWrapper>
  );
};
